// extracted by mini-css-extract-plugin
export default {"content":"updateTableRowModal_content__crAeb","message":"updateTableRowModal_message__euubo"};